module.exports = __webpack_public_path__ + "static/logo-small-503c49ec93da26d5c3a597391afdab9c.png";